module.exports = __webpack_public_path__ + "img/DE01986.e728b1cc.png";